var map = {
	"./icons/bolt.svg": [
		1099,
		3
	],
	"./icons/charging-station.svg": [
		1100,
		4
	],
	"./icons/cold.svg": [
		1101,
		5
	],
	"./icons/fire.svg": [
		1102,
		6
	],
	"./icons/hydrogen.svg": [
		1103,
		7
	],
	"./icons/services.svg": [
		1104,
		8
	],
	"./icons/solar-panel.svg": [
		1105,
		9
	],
	"./icons/thermometer-three-quarters.svg": [
		1106,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 859;
module.exports = webpackAsyncContext;